import React from "react";
import { connect } from "react-redux";
import { reduxForm, getFormValues, SubmissionError } from "redux-form";
import { requestForQuotationPath } from "routes";
import { Button, Breadcrumb } from "semantic-ui-react";
import Attachment from "../Form/Attachment";
import { lower } from "change-case";

import { MainBodyContent, K2ErrorModal, StatusTag } from "components";
import ProcessHistory from "../Details/ProcessHistory";
import ApproversE from "routes/ProcurementSystem/PurchaseRequisition/Create/Summary/Approvers";
import { scrollToFirstValidateFailElement } from "core/utilities";
import ActionCommentModal from "../Form/ActionCommentModal";
import RequestInfo from "../Form/RequestInfo";
import General from "../Form/General";
import { rfqStatus } from "../AttributeData";
import {
  initializeRFQ,
  getRFQDetail,
  getRFQGOAWorkFlowEditMode,
  updateRFQ,
  cancelRFQ,
  clearRFQData,
  getRFQErrorWorkFlow,
  clearReload,
  getGOAItem,
} from "ducks/rfq";
import { getProjectByCompany } from "ducks/goa";
import { showModal, toastError } from "ducks/app";
import { getPurchaseUsers } from "ducks/member";
import {
  validateAttachments,
  validateQuotationAttachments,
  validateField,
} from "../helper";

import { BottomActionsContainer } from "./styled";
import { RFQStdCont } from "../styled";
import r from "reactotron-react-js";
const EditRequestForQuotation = (props) => {
  const {
    change,
    valueForm,
    history,
    sapDetails,
    goaWorkFlow,
    k2workFlowError,
    isDetail = false,
  } = props;
  const [actionName, setActionName] = React.useState("");
  const [showDialogComment, setShowDialogComment] = React.useState(false);

  React.useEffect(() => {
    const { match } = props;
    window.scrollTo(0, 0);
    if (match && match.params && match.params.rfqId) {
      props.getRFQDetail(match.params.rfqId, history, true);
    }
    props.initializeRFQ(isDetail);
    return () => {
      props.clearRFQData();
    };
  }, []);

  React.useEffect(() => {
    props.clearReload();
  }, [props.sapDetailsReload]);

  React.useEffect(() => {
    if (valueForm.amountAfterDiscount) {
      props.getGOAItem(
        valueForm.companyCode,
        valueForm.amountAfterDiscount,
        valueForm.currencyCode,
      );
    }
  }, [valueForm.amountAfterDiscount]);

  React.useEffect(() => {
    if (sapDetails.companyCode) {
      if (props.projects[sapDetails.companyCode] === undefined) {
        if (sapDetails.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(sapDetails.companyCode);
        }
      }
      props.getPurchaseUsers(
        sapDetails.companyCode,
        sapDetails.purchasingGroup,
      );
    }
  }, [sapDetails.companyCode]);

  React.useEffect(() => {
    if (sapDetails.status && sapDetails.status !== 0) {
      props.getRFQErrorWorkFlow(
        sapDetails.procInstId,
        sapDetails.subProcInstId,
      );
    }
  }, [sapDetails.status]);

  React.useEffect(() => {
    if (!goaWorkFlow.loading) {
      props.getRFQGOAWorkFlowEditMode({
        creater: valueForm ? lower(valueForm.createdByUser) : "",
        requester: valueForm ? valueForm.requesterUser : "",
        companyCode: valueForm ? valueForm.companyCode : "",
        goaItemCode: valueForm ? valueForm.goaItemCode : "",
        amount: valueForm ? valueForm.netAmount : "",
        currency: valueForm ? valueForm.currencyCode : "",
        alternativeUserName: valueForm ? valueForm.alternativePurchaseUser : "",
        purchaseGroup: valueForm ? valueForm.purchasingGroup : "",
      });
    }
  }, [
    valueForm.createdByUser,
    valueForm.requesterUser,
    valueForm.goaItemCode,
    valueForm.amountAfterDiscount,
    valueForm.alternativePurchaseUser,
    valueForm.purchasingGroup,
  ]);

  const onSubmitForm = () => {
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    return sleep(100).then(() => {
      let errors = validateField(valueForm);
      if (errors.rfqItemVendorTotalAmounts) {
        props.toastError(
          `The Discount Amount can't be more than Total Amount,Please check again.`,
        );
      }
      if (actionName === "cancel") {
        if (!valueForm.actionComment) {
          errors.actionComment = "Required!";
        }
      }
      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors);
        throw new SubmissionError(errors);
      } else {
        //remove attachment is not use
        let xx = valueForm.isAdditionalPr
          ? valueForm.documentTypes.map((x) => (x.isAdditional ? x.code : null))
          : valueForm.documentTypes.map((x) =>
              !x.isAdditional ? x.code : null,
            );
        let attachCodes = xx
          ? xx.filter((x) => x)
          : valueForm.documentTypes.map((x) => x.code);
        if (attachCodes.length === 1) {
          xx = valueForm.documentTypes.map((x) =>
            !x.isAdditional ? x.code : null,
          );
          attachCodes = xx
            ? xx.filter((x) => x)
            : valueForm.documentTypes.map((x) => x.code);
        }
        valueForm.rfqAttachments = valueForm.rfqAttachments.filter(
          (x) =>
            attachCodes.indexOf(x.documentTypeCode) >= 0 ||
            x.documentTypeCode == "RFQ04",
        );
        valueForm.documentTypes
          .filter((x) => x.isAdditional === !valueForm.isAdditionalPr)
          .forEach((x) => {
            if (attachCodes.indexOf(x.code) < 0) {
              if (valueForm[`${lower(x.code)}`]) {
                valueForm[`${lower(x.code)}`] = undefined;
              }
            }
          });

        if (!valueForm.vatRate) valueForm.vatRate = 0;
        if (actionName === "submit" || actionName === "resubmit") {
          let missingAttachments = validateAttachments(valueForm);
          let missingQuotationAttachments = validateQuotationAttachments(
            valueForm.rfqItemVendorQuatationAttachtments,
            valueForm.vendorQuatationAttachtments,
          );
          if (missingAttachments.length) {
            props.showModal(
              true,
              "Please attach document!",
              <React.Fragment>
                <ul>
                  {missingAttachments.map((v) => (
                    <li>{v.fieldName}</li>
                  ))}
                </ul>
              </React.Fragment>,
            );
          } else if (!missingQuotationAttachments) {
            props.showModal(
              true,
              "Please attach document!",
              <React.Fragment>
                <ul>
                  <li>vendor quotation</li>
                </ul>
              </React.Fragment>,
            );
          } else {
            if (actionName === "submit") {
              props.updateRFQ(valueForm, history, true, false);
            } else {
              setShowDialogComment(false);
              props.updateRFQ(valueForm, history, false, true);
            }
          }
        } else if (actionName === "update") {
          props.updateRFQ(valueForm, history, false, false);
        } else if (actionName === "cancel") {
          setShowDialogComment(false);
          props.cancelRFQ(valueForm, history);
        }
      }
    });
  };

  const vendorSelected = () => {
    return (
      (valueForm.rfqItemVendorTotalAmounts || []).find(
        (v) => v.isVendorSelected,
      ) || {}
    );
  };

  return (
    <MainBodyContent
      headerTitle={
        <React.Fragment>
          {`Request for Quotation - Edit ${sapDetails ? (sapDetails.documentNumber ? `#${sapDetails.documentNumber}` : "") : ""}`}
          <span style={{ width: "1rem" }} />
          {sapDetails && (
            <StatusTag
              status={sapDetails && sapDetails.status}
              statusName={rfqStatus[sapDetails ? sapDetails.status : 0]}
            />
          )}
        </React.Fragment>
      }
      accessoriesHeader={
        <React.Fragment>
          <ApproversE
            loading={goaWorkFlow.loading}
            approvers={goaWorkFlow.data}
          />
          <Button
            basic
            circular
            type="button"
            content="View PO form"
            labelPosition="right"
            icon="clipboard list"
            onClick={() => window.open(sapDetails.urlPrintFormPo, "_blank")}
          />
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "RFQ",
              content: "Request for Quotation",
              link: true,
              onClick: () => history.push(requestForQuotationPath),
            },
            { key: "RFQEdit", content: "Edit", active: true },
          ]}
        />
      }
      accessoriesHeaderLeft={
        k2workFlowError.isError && (
          <K2ErrorModal checkK2Error={k2workFlowError} />
        )
      }
    >
      <RFQStdCont>
        <RequestInfo isEdit={true} change={change} />
        <General isEdit={true} change={change} />
        <Attachment isEdit={true} change={change} />
        <div style={{ marginTop: "1rem" }} />
        {valueForm && valueForm.status === 5 && (
          <React.Fragment>
            <ProcessHistory />
          </React.Fragment>
        )}
        {!k2workFlowError.isError && (
          <form onSubmit={props.handleSubmit(() => onSubmitForm())}>
            <React.Fragment>
              {(vendorSelected().cocStatus === 15 ||
                vendorSelected().cocStatus === 17) &&
              vendorSelected().cocMessage ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    whiteSpace: "pre-wrap",
                    fontWeight: "bold",
                    textAlign: "right",
                    color: "orange",
                  }}
                >
                  {vendorSelected().cocMessage}
                </div>
              ) : null}
              {(vendorSelected().vendorRegisterStatus || {}).registered ===
              false ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    whiteSpace: "pre-wrap",
                    fontWeight: "bold",
                    textAlign: "right",
                    color: "orange",
                  }}
                >
                  {`Supplier ${vendorSelected().vendorCode} : ${vendorSelected().vendorName} does not register EzProcure.`}
                </div>
              ) : null}
              <BottomActionsContainer>
                <div>
                  <Button
                    type="button"
                    content="Cancel Document"
                    color="red"
                    icon="close"
                    labelPosition="right"
                    style={{ marginRight: "0.3125rem" }}
                    onClick={() => {
                      setActionName("cancel");
                      setShowDialogComment(true);
                    }}
                  />
                </div>
                <div>
                  {valueForm && [0, "0"].indexOf(valueForm.status) >= 0 && (
                    <Button
                      type="submit"
                      content="Save"
                      icon="save"
                      labelPosition="right"
                      style={{ marginRight: "0.3125rem" }}
                      onClick={() => setActionName("update")}
                    />
                  )}
                  {valueForm && [5, "5"].indexOf(valueForm.status) >= 0 ? (
                    <Button
                      type="button"
                      content="Save & Re-Submit"
                      color="blue"
                      icon="save"
                      labelPosition="right"
                      style={{ marginRight: "0.3125rem" }}
                      // disabled={vendorSelected().cocStatus === 15}
                      onClick={() => {
                        setShowDialogComment(true);
                        setActionName("resubmit");
                      }}
                    />
                  ) : (
                    <Button
                      type="submit"
                      content="Save & Submit"
                      color="blue"
                      icon="save"
                      labelPosition="right"
                      style={{ marginRight: "0.3125rem" }}
                      // disabled={vendorSelected().cocStatus === 15}
                      onClick={() => setActionName("submit")}
                    />
                  )}
                </div>
              </BottomActionsContainer>
            </React.Fragment>
          </form>
        )}
      </RFQStdCont>
      {showDialogComment && (
        <ActionCommentModal
          submit={props.handleSubmit(() => onSubmitForm())}
          setShowDialogComment={setShowDialogComment}
          actionName={actionName}
        />
      )}
    </MainBodyContent>
  );
};

const mapStateToProps = (state, props) => {
  const projectCompanyLoading = state.goa.projectCompanyLoading;
  const projects = state.goa.projects;
  var valueForm = getFormValues("formRFQ")(state) || {};
  var sapDetails = state.rfq.sapDetails;
  var sapDetailsReloadData = state.rfq.sapDetailReload;
  // if (sapDetails.isReload) {
  //   sapDetails.data = {
  //     ...valueForm,
  //     ...sapDetails.data,
  //     id: valueForm.id,
  //     title: valueForm.title,
  //     requesterUser: valueForm.requesterUser,
  //     category: valueForm.category,
  //     documentDate: valueForm.documentDate,
  //     goaItemCode: valueForm.goaItemCode,
  //     remark: valueForm.remark,
  //     purchaseOrderId: valueForm.purchaseOrderId,
  //     statusActivity: valueForm.statusActivity,
  //     documentNumber: valueForm.documentNumber,
  //     priority: valueForm.priority,
  //     isSpecialPr: valueForm.isSpecialPr,
  //     specialPrTitle: valueForm.specialPrTitle,
  //     specialPrReason: valueForm.specialPrReason,
  //     isAdditionalPr: valueForm.isAdditionalPr,
  //     additionalPrReason: valueForm.additionalPrReason,
  //     additionalRefPoNumber: valueForm.additionalRefPoNumber,
  //     purchasingGroup: valueForm.purchGroupCode
  //   }

  // }
  if (sapDetailsReloadData == null) {
    sapDetails.data = {
      ...valueForm,
      ...sapDetails.data,
      id: valueForm.id,
      title: valueForm.title,
      requesterUser: valueForm.requesterUser,
      category: valueForm.category,
      documentDate: valueForm.documentDate,
      goaItemCode: valueForm.goaItemCode,
      remark: valueForm.remark,
      purchaseOrderId: valueForm.purchaseOrderId,
      statusActivity: valueForm.statusActivity,
      documentNumber: valueForm.documentNumber,
      priority: valueForm.priority,
      isSpecialPr: valueForm.isSpecialPr,
      specialPrTitle: valueForm.specialPrTitle,
      specialPrReason: valueForm.specialPrReason,
      isAdditionalPr: valueForm.isAdditionalPr,
      additionalPrReason: valueForm.additionalPrReason,
      additionalRefPoNumber: valueForm.additionalRefPoNumber,
      purchasingGroup: valueForm.purchGroupCode,
    };
  } else {
    if (sapDetailsReloadData.isReload) {
      sapDetails.data = {
        ...valueForm,
        ...sapDetails.data,
        id: valueForm.id,
        title: valueForm.title,
        requesterUser: valueForm.requesterUser,
        category: valueForm.category,
        documentDate: valueForm.documentDate,
        goaItemCode: valueForm.goaItemCode,
        remark: valueForm.remark,
        purchaseOrderId: valueForm.purchaseOrderId,
        statusActivity: valueForm.statusActivity,
        documentNumber: valueForm.documentNumber,
        priority: valueForm.priority,
        isSpecialPr: valueForm.isSpecialPr,
        specialPrTitle: valueForm.specialPrTitle,
        specialPrReason: valueForm.specialPrReason,
        isAdditionalPr: valueForm.isAdditionalPr,
        additionalPrReason: valueForm.additionalPrReason,
        additionalRefPoNumber: valueForm.additionalRefPoNumber,
        purchasingGroup: sapDetailsReloadData?.data?.purchGroupCode ?? null,
      };
    } 
  }

  return {
    initialValues: {
      ...sapDetails.data,
    },
    sapDetails: sapDetails.data || {},
    sapDetailsReload: sapDetails.isReload,
    projects,
    projectCompanyLoading,
    goaWorkFlow: state.rfq.goaWorkFlow,
    k2workFlowError: state.rfq.k2workFlowError,
    valueForm,
  };
};
const mapDispatchToProps = {
  initializeRFQ,
  getRFQDetail,
  getProjectByCompany,
  getRFQGOAWorkFlowEditMode,
  updateRFQ,
  cancelRFQ,
  clearRFQData,
  showModal,
  getRFQErrorWorkFlow,
  toastError,
  clearReload,
  getGOAItem,
  getPurchaseUsers,
};

const contForm = reduxForm({
  form: "formRFQ",
  enableReinitialize: true,
})(EditRequestForQuotation);

export default connect(mapStateToProps, mapDispatchToProps)(contForm);
